import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ChevronDown } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React, { createRef, PureComponent } from 'react';
import css from './ImageTextLeft.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ImageTextLeft = /*#__PURE__*/function (_PureComponent) {
  _inherits(ImageTextLeft, _PureComponent);

  var _super = _createSuper(ImageTextLeft);

  function ImageTextLeft(props) {
    var _this;

    _classCallCheck(this, ImageTextLeft);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "animateScroll", function (scrollTop) {
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickJumper", function () {
      var rootEl = _this.rootEl.current;

      if (!rootEl) {
        return false;
      }

      var distTop = rootEl.offsetTop + rootEl.offsetHeight;
      var scrollAmount = distTop - _this.navHeight;

      _this.animateScroll(scrollAmount);

      return scrollAmount;
    });

    _defineProperty(_assertThisInitialized(_this), "getJumper", function () {
      var _this$props = _this.props,
          subtitle = _this$props.subtitle,
          subtitleUrl = _this$props.subtitleUrl;
      /* eslint-disable jsx-a11y/control-has-associated-label */

      return subtitleUrl ? /*#__PURE__*/_jsx("a", {
        className: [css.jumper, css.jumperLink],
        href: subtitleUrl,
        dangerouslySetInnerHTML: {
          __html: subtitle
        }
      }) : /*#__PURE__*/_jsxs("button", {
        className: css.jumper,
        onClick: _this.onClickJumper,
        type: "button",
        children: [/*#__PURE__*/_jsx("span", {
          className: css.jumperText,
          dangerouslySetInnerHTML: {
            __html: subtitle
          }
        }), /*#__PURE__*/_jsx(ChevronDown, {})]
      });
    });

    _this.rootEl = /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(ImageTextLeft, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nav = document.querySelector('.ov-nav');
      this.navHeight = nav && nav.offsetHeight ? nav.offsetHeight : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          description = _this$props2.description,
          image = _this$props2.image,
          title = _this$props2.title;
      return /*#__PURE__*/_jsx("header", {
        className: css.root,
        ref: this.rootEl,
        children: /*#__PURE__*/_jsxs("div", {
          className: css.inner,
          children: [/*#__PURE__*/_jsxs("div", {
            className: css.text,
            children: [title && /*#__PURE__*/_jsx("h1", {
              className: css.title,
              dangerouslySetInnerHTML: {
                __html: title
              }
            }), this.getJumper(), description && /*#__PURE__*/_jsx("p", {
              className: css.description,
              dangerouslySetInnerHTML: {
                __html: description
              }
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: css.image,
            style: {
              backgroundImage: "url(".concat(image, ")")
            },
            children: title && /*#__PURE__*/_jsx("h1", {
              className: css.imageTitle,
              dangerouslySetInnerHTML: {
                __html: title
              }
            })
          })]
        })
      });
    }
  }]);

  return ImageTextLeft;
}(PureComponent);

ImageTextLeft.displayName = 'ImageTextLeft';
ImageTextLeft.defaultProps = {
  description: false,
  image: false,
  subtitleUrl: false,
  title: false
};
ImageTextLeft.propTypes = {
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitle: PropTypes.string.isRequired,
  subtitleUrl: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default ImageTextLeft;